import { createContext, useContext } from 'react';

export interface VoiceContextValue {
  isListening: boolean;
  setIsListening: (v: boolean) => void;
}

export const VoiceContext = createContext<VoiceContextValue>({
  isListening: false,
  setIsListening: () => {},
});

export function useVoiceContext() {
  return useContext(VoiceContext);
}
